









































































import { Component, Watch } from 'vue-property-decorator';
import { MswAppTitle }  from '@/shared/msw-app-title';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { InfoState } from '@/core';
import { MswApiService } from '@/shared/msw-api-service';
import { SwTable, TableEntry, TableColumnConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { SwExpandableTextfield, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { CreateElement, VNode } from 'vue';

const cssPrefix = 'applySecureUpgrade';

@Component({
  components:{
    ...UUIFComponents,
    MswAppTitle,
    SwExpandableTextfield,
    SwTextfield,
    SwTable,
    SwDropMenu,
  },
})

export default class ApplySecureUpgrade extends SwExtendedVue {
  cssPrefix = cssPrefix;
  mainTableData: TableEntry[] = [];
  filtered: TableEntry[] = [];
  tableConfig: TableColumnConfig[] = [];
  menuOpened: boolean = false;
  apiResponse: any = '';
  searchValue: any = '';
  menuItems: DropMenuItem[] = [];
  selectedMenuItem: string = '';
  search: any = '';
  textExpanded : boolean = false;
  selectedTableEntry: any = '';
  selectedRow: any = '';

  @Watch('search')
  whenSearchEmpty() {
    if (this.search === '') {
      this.filtered = this.mainTableData;
    }
  }

  getTableDataFromApi() {
    console.warn(this.$route.query);
    const template = {
      serNo: this.$route.query.srNo,
      id: this.$route.query.upgradeId,
    };
    this.$store.commit('startLoading');
    MswApiService.promotions.getPromoSecure(template)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'NOK') {
        return this.showMessage('failed', resp.msgDesc);
      }
      this.apiResponse = resp.content;
      this.makeTableData();
      this.makeDropDownOptions();
    });
  }

  reloadData() {
    this.getTableDataFromApi();
  }

  @Watch('searchValue')
  whenSearchValueEmpty() {
    if (this.searchValue === '') {
      this.filtered = this.mainTableData;
    }
  }

  makeTableData() {
    const tableData = this.apiResponse.secUpFrmSerialNumbers.map((each: any, index: any) => {
      return {
        ...each,
        _key: index.toString(),
      };
    });
    this.selectedRow = tableData[0];
    this.mainTableData = tableData;
    this.filtered = this.mainTableData;
  }

  handleClear() {
    this.search = '';
  }

  confirm() {
    this.handleConfirm();
  }

  handleConfirm() {
    this.$router.push({ path: 'transfersecureupgrade',
      query: {
        frm: this.selectedRow.serialNumber,
        upgradeID: this.$route.query.upgradeId || '',
        snbuser: this.$route.query.snbuser,
        to: this.apiResponse.upgradeUnit.split('-')[0]
        .trim(),
      },
    });
  }

  cancel() {
    this.$router.go(-1);
  }

  filterSearch() {
    const searchedItem = this.tableConfig.find((el: any) => el.title === this.selectedMenuItem);
    // @ts-ignore
    const filtered = this.mainTableData.filter((el: any) => {
      // @ts-ignore
      return el[searchedItem.key].toLowerCase()
      .toString()
      .trim()
      .includes(this.searchValue
      .toLowerCase()
      .toString()
      .trim());
    });
    this.filtered = filtered;
  }

  makeDropDownOptions() {
    const options = this.tableConfig.filter((each: any) => each.key.toLowerCase() !== 'index');
    this.menuItems = options.map((each: any) => {
      return {
        id: each.title,
        content: each.title,
      };
    });
  }

  updateTableData() {
    const searchedItem = this.tableConfig.find((el: any) => el.title === 'Serial Number');
    // @ts-ignore
    const filtered = this.mainTableData.filter((el: any) => {
      // @ts-ignore
      return el[searchedItem.key].toLowerCase()
      .toString()
      .trim()
      .includes(this.search
      .toLowerCase()
      .toString()
      .trim());
    });
    this.filtered = filtered;
  }

  mounted() {
    this.makeTableHeaders();
    this.getTableDataFromApi();
  }

  handleChange(item: any) {
    this.selectedRow = item;
  }

  makeTableHeaders() {
    this.tableConfig = [
      {
        key: 'selectionItem',
        width: 50,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div>
              <input type="radio" name="select-radio" onChange={() => this.handleChange(data.entry)}/>
            </div>
          ) as VNode;
        },
      },
      {
        key: 'index',
        type: 'index',
      },
      {
        key: 'name',
        dataKey: 'name',
        title: 'Name',
      },
      {
        key: 'serialNumber',
        dataKey: 'serialNumber',
        title: this.$t('products.serialnumber')
        .toString(),
      },
      {
        key: 'productLine',
        dataKey: 'productLine',
        title: this.$t('products.productline')
        .toString(),
      },
      {
        key: 'registrationCode',
        dataKey: 'registrationCode',
        title: this.$t('myPromotions.productline')
        .toString(),
      },
      {
        key: 'createdDate',
        dataKey: 'createdDate',
        title: this.$t('products.productline')
        .toString(),
      },
    ];
  }

  onClickMenuButton() {
    this.menuOpened = !this.menuOpened;
  }

  onSelectItem(itemId: string) {
    this.selectedMenuItem = itemId;
    this.onClickMenuButton();
  }

  showMessage(infoType: string, infoMsg: string) {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }
}
